export const getClampedValue = (value: number): number => {
    return value > 100 ? 100 : value < 0 ? 0 : value;
};

export const getPercentage = (value: number, total: number): number => {
    return (value * 100) / total;
};
